import { Label } from "@mui/icons-material";

const equaroDomain = "https://api-staging.eqaroguarantees.com/user/v1";

//Live
//const BASE_URL = "https://retailapi.kipinn.com/";

//Development
//const BASE_URL = "http://20.64.169.133:3003/";
//const PROP_VIEW_URL = "https://view.kipinn.in/p/";
//const OWNER_VIEW_FORM_URL ="https://20.64.169.133:3006/form/"

//const OWNER_VIEW_PDF_URL = "https://20.64.169.133:3006/pdf/"
// const BASE_URL = "http://54.196.139.145:3001/";
// const BASE_URL = "https://stagingcallback.kipinn.com/";

//Live 
const BASE_URL = "https://retailapi.kipinn.com/";
const OWNER_VIEW_FORM_URL ="https://view.kipinn.in/form/"
const PROP_VIEW_URL = "https://view.kipinn.in/p/";

const GetAccessToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  if (user) return user.token;

  return null;
};

const GetUserId = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  if (user) return user.userId;

  return null;
};

const Config = {
  AxiosConfig: {
    headers: {
      authorization: `${GetAccessToken()}`,
      id: GetUserId(),
    },
  },

  userType: {
    SUPERADMIN: 1,
    MARKETING: 3,
    OPERATION: 2,
  },
  eqaroDomain: equaroDomain,
  domain: BASE_URL,
  apiUrl: BASE_URL + "api",
  certificateUrl: BASE_URL + "api/upload/CERTIFICATES/",
  docUrl: BASE_URL + "api/upload/",
  sessionExpiredTime: 60, // in minutes
  idleTime: 15, // in mins
  propViewURL: PROP_VIEW_URL,
  ownerViewFormURL: OWNER_VIEW_FORM_URL,
  //ownerViewPdf: OWNER_VIEW_PDF_URL,
  roomTypeMapping: {
    1: "Single sharing",
    2: "Double sharing",
    3: "Triple sharing",
    4: "Three plus sharing",
  },

  roomStatus: {
    1: "Vacant",
    2: "Semi occupied",
    3: "Occupied",
    4: "Inactive",
  },
  FLAT_STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
  },
  // ROOM_STATUS: {
  //   VACANT: 1,
  //   Semi_Occupied: 2,
  //   Occupied: 3,
  //   Inactive: 4,
  // },
  GENDER_PREFERENCE: {
    MALE: 1,
    FEMALE: 2,
    BOTH: 3,
  },
  TENANT_STATUS: {
    UNVERIFIED: 1,
    VACANT: 2,
    LINKED: 3,
    REQUESTED: 4,
    OCCUPIED: 5,
    MOVING_OUT: 6,
    RESERVED: 7,
  },
  ROOM_TYPES: {
    SINGLE_SHARING: 1,
    DOUBLE_SHARING: 2,
    TRIPLE_SHARING: 3,
    THREE_PLUS_SHARING: 4,
    RK_1: 5,
    BHK_1: 6,
    BHK_2: 7,
    BHK_3: 8,
    BHK_3_PLUS: 9,
  },
  BED_STATUS: {
    VACANT: 1,
    VACANT_RESERVED: 2,
    OCCUPIED: 3,
    MOVING_OUT: 4,
    RESERVED: 5,
  },
  ROOM_STATUS: {
    VACANT: 1,
    SEMI_OCCUPIED: 2,
    OCCUPIED: 3,
    INACTIVE: 4,
  },

  dueType: {
    RENT: 1,
    SECURITY: 2,
    MAINTENANCE: 3,
    ELECTRICITY: 4,
    REGISTRATION: 5,
    TECH_CHARGES: 6,
    OTHER: 7,
    AGREEMENT_CHARGE: 8,
    FOOD: 9,
    FINE: 10,
    SETTLEMENT: 11,
    WIFI: 12,
    GAS: 13,
    MAID_CHARGES: 14,
    DAMAGE: 15,
    KEY_CHARGES: 16,
    LAUNDRY_CHARGES: 17,
    MOVE_OUT_CHARGES: 19,
    GUEST_CHARGES: 20,
  },

  SOURCE: {
    FACEBOOK: 1,
    GOOGLE: 2,
    INSTAGRAM: 3,
    FLATMATE: 4,
    MAGICBRICKS: 5,
    ACRES: 6,
    HOUSING: 7,
    WEBSITE: 8,
    EQARO: 9,
    NOBROKER: 10,
    OLX: 11,
    QUIKR: 12,
    OTHERS: 100,
  },
  LEAD_STATUS: {
    NEW: 1,
    FOLLOW_UP: 2,
    VISIT_SCHEDULED: 3,
    VISIT_DONE: 4,
    CONVERTED: 5,
    NOT_INTERESTED: 6,
    CONTACTED: 7,
    INTERESTED: 8,
    INVALID: 9,
    ON_HOLD: 10,
    NOT_ANSWERED: 11,
  },
  RENT_RANGE: {
    ZERO_TO_FIVE_K: 1,
    FIVE_TO_TEN_K: 2,
    TEN_TO_FIFTEEN_K: 3,
    FIFTEEN_TO_TWENTY_K: 4,
    TWENTY_TO_TWENTY_FIVE_K: 5,
    TWENTY_FIVE_TO_THIRTY_K: 6,
    THIRTY_TO_THIRTY_FIVE_K: 7,
    THIRTY_FIVE_TO_FORTY_K: 8,
    FORTY_TO_FORTY_FIVE_K: 9,
    FORTY_FIVE_TO_FIFTY_K: 10,
    FIFTY_PLUS: 11,
  },
  STAFF_ROLES: {
    ADMIN: 1,
    WARDEN: 2,
    ELECTRICIAN: 3,
    PLUMBER: 4,
    LAUNDRY: 5,
    CARPENTER: 6,
    PARTNER: 7,
    COOK: 8,
    HOUSEKEEPING: 9,
    SALESPERSON: 10,
    SECURITYGUARD: 11,
    FINANCEADMIN: 12,
    BACK_OFFICE: 13,
    HELPDESK: 14,
    BROKER: 15,
    AC_TECH: 16,
    PURIFIER_TECH: 17,
  },
  // USER_TYPE: {
  //   CLIENT: 1,
  //   TENANT: 2,
  //   STAFF: 3,
  //   VENDOR: 4,
  //   LANDLORD: 5,
  // },
   USER_TYPE: {
    CLIENT: 1,
    STAFF: 2,
    LANDLORD: 3,
    CHANNEL_PARTNER: 4,
    TENANT: 5,
  },
  PLATFORM: {
    ANDROID: 1,
    IOS: 2,
    WEB: 3,
  },

  PERMISSIONS: {
    MANANGE_INVENTORY: 0,
    MANANGE_TENANTS: 1,
    MANANGE_BANKS: 2,
    MANANGE_STAFF: 3,
    MANANGE_DUES: 4,
    MANANGE_EXTRACHARGES: 5,
    MANANGE_EXPENSES: 6,
    MANANGE_LEADS: 7,
    MANANGE_SENDNOTICES: 8,
    MANANGE_ATTENDANCES: 9,
    MANANGE_COLLECTIONS: 10,
    MANANGE_TRANS_RESTORE: 11,
    MANANGE_REQUESTS: 12,
    MANANGE_REPORTS: 13,
    MANANGE_COMPLAINTS: 14,
    MANANGE_LANDLORD: 15,
    MANANGE_PROPERTY_ASSETS: 16,
  },

  RENTAL_BOND: {
    NOT_REQUIRED: 1,
    MANDATORY: 2,
  },
  ONLINE_PAYMENT: {
    ENABLED: 1,
    DISABLED: 0,
  },
  OCCUPANCY_STATUS: {
    PENDING: 1,
    REQUESTED: 2,
    OCCUPIED: 3,
    MOVING_OUT: 4,
    RESERVED: 5,
  },
  REQUEST_TYPE: {
    ONBOARDING: 1,
    MOVEOUT: 2,
    REFUND: 3,
    GUEST: 4,
  },
  PROPERTY_STATUS: {
    PENDING: 1,
    COMPLETED: 2,
    ACTIVE: 3,
    INACTIVE: 4,
    DELETED: 5,
  },
  RENTAL_OPTIONS: {
    MONTHLY: 1,
    SHORT_DURATION: 2,
    OTHERS: 3,
  },
  PROPERTY_OWNERSHIP: {
    OWNER: 1,
    CO_OWNER: 2,
    POA: 3,
    BUILDER: 4,
    CHANNEL_BROKER: 5,
    CO_BROKER: 6,
  },
  INVENTORY_AGE: {
    NEW: 1,
    ONE: 2,
    TWO: 3,
    THREE: 4,
    FOUR: 5,
    FIVE: 6,
    MORE: 7,
  },
  LANDLORD_PROPERTY_TYPE: {
    PG: 1,
    APARTMENT_FLAT: 2,
    //VILLA: 3,
    VILLA_INDEPENDENT_FLOOR: 4,
    SHOP_SHOWROOM: 5,
    OFFICE: 6,
    PLOT: 7,
    //WAREHOUSE: 8,
    //SHOWROOM: 9,
    //MIXED_USE: 10,
  },
  LISTING_TYPE: {
    RENT: 1,
    SALE: 2,
    LEASE: 3,
  },
  REQUEST_STATUS: {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    CANCELLED: 4,
    INPROGRESS: 5
  },

  INVENTORY_BELONGS_TO: {
    OWNER: 1,
    BROKER: 2,
  },

  PROPERTY_FEATURES: {
    CLOSE_TO_BUS_STOP: 0,
    CLOSE_TO_RAILWAY_STATION: 1,
    CLOSE_TO_AIRPORT: 2,
    CLOSE_TO_HOSPITAL: 3,
    CLOSE_TO_TEMPLE: 4,
    CLOSE_TO_GROCERY_STORE: 5,
    POWER_BACKUP: 6,
    LIFT: 7,
    CLUB_HOUSE: 8,
    GYM: 9,
    SWIMMING_POOL: 10,
    LIBRARY: 11,
    CHILDREN_PLAY_AREA: 12,
    GATED_COMMUNITY: 13,
    SECURITY_247: 14,
    FIRE_FIGHTING_SYSTEM: 15,
    SMOKE_DETECTOR: 16,
    PET_FRIENDLY :17,
  },

  INVENTORY_STATUS: {
    AVAILABLE: 1,
    //CLOSED: 2,
    BOOKED: 2,
    LEASED: 3,
    HOLD: 4, //A customer has shown interest and the unit is temporarily held
    //BOOKED: 4, // One-time transaction, Deal ends, Revenue = brokerage
    MAINTENANCE: 5,
    UNAVAILABLE: 6, //Inventory is no longer available via you. In this case, cancel all active deals.
    DELETE: 7,
    UNVERIFIED: 8,
  },

  DEAL_STATUS: {
    INQUIRY: 1,
    VISIT_SCHEDULED: 2,
    NEGOTIATION: 3,
    BOOKED: 4,
    ACTIVE_LEASE: 5,
    CANCELLED: 6,
    LOST: 7,
    END_OF_LEASE: 8,
  },

  USER_TYPE_RETAIL: {
    CLIENT: 1,
    STAFF: 2,
    LANDLORD: 3,
    CHANNEL_PARTNER: 4,
  },

  PAID_BY_TYPE: {
    BUYER: 1,
    SELLER: 2,
    BOTH: 3,
  },

  PAID_BY_RENT:{
    TENANT: 1,
    OWNER: 2,
    BOTH: 3,
  },

  TRANSACTION_MODES: {
    CASH: 1,
    UPI: 2,
    NET_BANKING: 3,
    CARD: 4,
  },

  ENQUIRY_SOURCE: {
    FACEBOOK: 1,
    GOOGLE: 2,
    INSTAGRAM: 3,
    FLATMATE: 4,
    MAGICBRICKS: 5,
    ACRES: 6,
    HOUSING: 7,
    WEBSITE: 8,
    EQARO: 9,
    NOBROKER: 10,
    OLX: 11,
    QUIKR: 12,
    OTHERS: 100,
  },

  STAMP_REQUIRED: {
    YES: 1,
    NO: 0,
  },

  STAMP_PAPERS_STATUS: {
    AVAILABLE: 1,
    ALLOTTED: 2,
  },

  TENANT_RELATIONSHIP_TYPE: {
    SPOUSE: 1,
    FATHER: 2,
    MOTHER: 3,
    FRIEND: 4,
    COLLEAGUE: 5,
    RELATIVE: 6,
    OTHER: 7,
  }

};


export const tenantRelationshipOptions = [
  { value: Config.TENANT_RELATIONSHIP_TYPE.SPOUSE, label: "Spouse" },
  { value: Config.TENANT_RELATIONSHIP_TYPE.FATHER, label: "Father" },
  { value: Config.TENANT_RELATIONSHIP_TYPE.MOTHER, label: "Mother" },
  { value: Config.TENANT_RELATIONSHIP_TYPE.FRIEND, label: "Friend" },
  { value: Config.TENANT_RELATIONSHIP_TYPE.COLLEAGUE, label: "Colleague" },
  { value: Config.TENANT_RELATIONSHIP_TYPE.RELATIVE, label: "Relative" },
  { value: Config.TENANT_RELATIONSHIP_TYPE.OTHER, label: "Other" },
];

export const enquirySourceOptions = [
  { value: Config.ENQUIRY_SOURCE.FACEBOOK, label: "Facebook" },
  { value: Config.ENQUIRY_SOURCE.GOOGLE, label: "Google" },
  { value: Config.ENQUIRY_SOURCE.INSTAGRAM, label: "Instagram" },
  { value: Config.ENQUIRY_SOURCE.FLATMATE, label: "Flatmate" },
  { value: Config.ENQUIRY_SOURCE.MAGICBRICKS, label: "Magicbricks" },
  { value: Config.ENQUIRY_SOURCE.ACRES, label: "99 Acres" },
  { value: Config.ENQUIRY_SOURCE.HOUSING, label: "Housing" },
  { value: Config.ENQUIRY_SOURCE.WEBSITE, label: "Website" },
  { value: Config.ENQUIRY_SOURCE.EQARO, label: "Eqaro" },
  { value: Config.ENQUIRY_SOURCE.NOBROKER, label: "NoBroker" },
  { value: Config.ENQUIRY_SOURCE.OLX, label: "OLX" },
  { value: Config.ENQUIRY_SOURCE.QUIKR, label: "Quikr" },
  { value: Config.ENQUIRY_SOURCE.OTHERS, label: "Others" },
];

export const transactionModes = [
  { value: Config.TRANSACTION_MODES.CASH, label: "Cash" },
  { value: Config.TRANSACTION_MODES.UPI, label: "UPI" },
  { value: Config.TRANSACTION_MODES.NET_BANKING, label: "Net Banking" },
  { value: Config.TRANSACTION_MODES.CARD, label: "Card" }
]

export const stageOptions = [
  { value: Config.DEAL_STATUS.INQUIRY, label: "Inquiry" },
  { value: Config.DEAL_STATUS.VISIT_SCHEDULED, label: "Visit Scheduled" },
  { value: Config.DEAL_STATUS.NEGOTIATION, label: "Negotiation" },
  { value: Config.DEAL_STATUS.BOOKED, label: "Booked" },
  { value: Config.DEAL_STATUS.ACTIVE_LEASE, label: "Active Lease" },
  { value: Config.DEAL_STATUS.LOST, label: "Lost" },
]

export const editStageOptions = [
  { value: Config.DEAL_STATUS.INQUIRY, label: "Inquiry" },
  { value: Config.DEAL_STATUS.VISIT_SCHEDULED, label: "Visit Scheduled" },
  { value: Config.DEAL_STATUS.NEGOTIATION, label: "Negotiation" },
  { value: Config.DEAL_STATUS.BOOKED, label: "Booked" },
  { value: Config.DEAL_STATUS.ACTIVE_LEASE, label: "Active Lease" },
  { value: Config.DEAL_STATUS.CANCELLED, label: "Cancelled" },
  { value: Config.DEAL_STATUS.LOST, label: "Lost" },
]

export const paidByOptions = [
  { value: Config.PAID_BY_TYPE.BUYER, label: "Buyer" },
  { value: Config.PAID_BY_TYPE.SELLER, label: "Seller" },
  { value: Config.PAID_BY_TYPE.BOTH, label: "Both" },
];

export const paidByRent = [
  { value: Config.PAID_BY_RENT.TENANT, label: "Tenant" },
  { value: Config.PAID_BY_RENT.OWNER, label: "Owner" },
  { value: Config.PAID_BY_RENT.BOTH, label: "Both" },
];

export const propertyAvailabilityStatus = [
  { value: Config.INVENTORY_STATUS.AVAILABLE, label: "Available" },
  { value: Config.INVENTORY_STATUS.BOOKED, label: "Booked" },
  { value: Config.INVENTORY_STATUS.LEASED, label: "Leased" },
  { value: Config.INVENTORY_STATUS.HOLD, label: "Hold" },
  { value: Config.INVENTORY_STATUS.UNVERIFIED, label: "Unverified"},
];

export const propertyFeatures = [
  { value: Config.PROPERTY_FEATURES.PET_FRIENDLY, label: "Pet Friendly" },
  { value: Config.PROPERTY_FEATURES.CLOSE_TO_BUS_STOP, label: "Bus Stop" },
  { value: Config.PROPERTY_FEATURES.CLOSE_TO_RAILWAY_STATION, label: "Railway Station" },
  { value: Config.PROPERTY_FEATURES.CLOSE_TO_AIRPORT, label: "Airport" },
  { value: Config.PROPERTY_FEATURES.CLOSE_TO_HOSPITAL, label: "Hospital" },
  { value: Config.PROPERTY_FEATURES.CLOSE_TO_TEMPLE, label: "Temple" },
  { value: Config.PROPERTY_FEATURES.CLOSE_TO_GROCERY_STORE, label: "Grocery Store" },
  { value: Config.PROPERTY_FEATURES.POWER_BACKUP, label: "Power Backup" },
  { value: Config.PROPERTY_FEATURES.LIFT, label: "Lift" },
  { value: Config.PROPERTY_FEATURES.CLUB_HOUSE, label: "Club House" },
  { value: Config.PROPERTY_FEATURES.GYM, label: "Gym" },
  { value: Config.PROPERTY_FEATURES.SWIMMING_POOL, label: "Swimming Pool" },
  { value: Config.PROPERTY_FEATURES.LIBRARY, label: "Library" },
  { value: Config.PROPERTY_FEATURES.CHILDREN_PLAY_AREA, label: "Children Play Area" },
  { value: Config.PROPERTY_FEATURES.GATED_COMMUNITY, label: "Gated Community" },
  { value: Config.PROPERTY_FEATURES.SECURITY_247, label: "24×7 Security" },
  { value: Config.PROPERTY_FEATURES.FIRE_FIGHTING_SYSTEM, label: "Fire Fighting System" },
  { value: Config.PROPERTY_FEATURES.SMOKE_DETECTOR, label: "Smoke Detector" },
];

export const rentRange = [
  { value: Config.RENT_RANGE.ZERO_TO_FIVE_K, label: "0-5K" },
  { value: Config.RENT_RANGE.FIVE_TO_TEN_K, label: "5K-10K" },
  { value: Config.RENT_RANGE.TEN_TO_FIFTEEN_K, label: "10K-15K" },
  { value: Config.RENT_RANGE.FIFTEEN_TO_TWENTY_K, label: "15K-20K" },
  { value: Config.RENT_RANGE.TWENTY_TO_TWENTY_FIVE_K, label: "20K-25K" },
  { value: Config.RENT_RANGE.TWENTY_FIVE_TO_THIRTY_K, label: "25K-30K" },
  { value: Config.RENT_RANGE.THIRTY_TO_THIRTY_FIVE_K, label: "30K-35K" },
  { value: Config.RENT_RANGE.TWENTY_FIVE_TO_THIRTY_K, label: "35K-40K" },
  { value: Config.RENT_RANGE.FORTY_TO_FORTY_FIVE_K, label: "40K-45K" },
  { value: Config.RENT_RANGE.FORTY_FIVE_TO_FIFTY_K, label: "45K-50K" },
  { value: Config.RENT_RANGE.FIFTY_PLUS, label: "50K+" },
];

export const leadStatus = [
  { value: Config.LEAD_STATUS.NEW, label: "New" },
  { value: Config.LEAD_STATUS.FOLLOW_UP, label: "Follow Up" },
  { value: Config.LEAD_STATUS.VISIT_SCHEDULED, label: "Visit Scheduled" },
  { value: Config.LEAD_STATUS.VISIT_DONE, label: "Visit Done" },
  { value: Config.LEAD_STATUS.CONVERTED, label: "Converted" },
  { value: Config.LEAD_STATUS.NOT_INTERESTED, label: "Not Interesed" },
];

export const dueTypes = [
  { value: 1, label: "Rent" },
  { value: 2, label: "Security" },
  { value: 3, label: "Maintenance" },
  { value: 4, label: "Electricity" },
  { value: 5, label: "Registration" },
  { value: 6, label: "Tech Charges" },
  // { value: 7, label: "Other" },
  { value: 8, label: "Agreement Charges" },
  { value: 9, label: "Food Charges" },
  { value: 10, label: "Fine" },
  { value: Config.dueType.WIFI, label: 'Wifi Bill' },
  { value: Config.dueType.GAS, label: 'Gas Bill' },
  { value: Config.dueType.MAID_CHARGES, label: 'Maid Charges' },
  { value: Config.dueType.DAMAGE, label: 'Damage Charges' },
  { value: Config.dueType.KEY_CHARGES, label: 'Key Loss Charges' },
  { value: Config.dueType.LAUNDRY_CHARGES, label: 'Laundry Bill' },
  { value: Config.dueType.MOVE_OUT_CHARGES, label: 'MoveOut Charges' },
  { value: Config.dueType.GUEST_CHARGES, label: 'Guest Charges' },
];
export const addDuesTypesForExtendStay = [
  { value: 4, label: "Electricity Bill" },
  { value: 3, label: "Maintenance Charge" },
  { value: 5, label: "Registration Charge" },
  { value: 9, label: "Food Bill" },
  { value: 7, label: "Other" },
];
export const availableAmenities = [
  { label: "Balcony", value: "balcony" },
  { label: "Ac", value: "ac" },
  { label: "Tv", value: "tv" },
  { label: "Attached Bathroom", value: "attached bathroom" },
  { label: "Wi-Fi", value: "wi-fi" },
  { label: "Washing Machine", value: "washing machine" },
];
export const assetAssignTo = [
  { value: 1, label: "Tenant" },
  { value: 2, label: "Maintenance Staff" },
  { value: 3, label: "Unassigned" },
];
export const assetAssignStatus = [
  { value: 1, label: "Active" },
  { value: 2, label: "In Maintenance" },
  { value: 3, label: "Disposed" },
  { value: 4, label: "In Use" },
];
export const PaginationLimit = 10;

export const plans = [
  { value: 1, label: "Bronze" },
  { value: 2, label: "Silver" },
  { value: 3, label: "Gold" },
];

export const inventoryBelongsTo = [
  // { value: 1, label: "Client" },
  // { value: 2, label: "Staff" },
  { value: 3, label: "Owner" },
  { value: 4, label: "Broker" },
];

export const bhk_options = [
  { value: 1, label: "1 RK" },
  { value: 2, label: "Studio", },
  { value: 3, label: "1" },
  { value: 4, label: "1.5" },
  { value: 5, label: "2" },
  { value: 6, label: "2.5" },
  { value: 7, label: "3" },
  { value: 8, label: "3.5" },
  { value: 9, label: "4" },
  { value: 10, label: "4.5" },
  { value: 11, label: "5" },
  { value: 12, label: "6" },
  { value: 13, label: "7" },
  { value: 14, label: "8" },
  { value: 15, label: "9" },
];

export const ForUs = (userId) => {
  if (userId === "e9ca6870-e80a-4df1-9b27-b6986fd6244a") {
    return true;
  }

  return false;
};

export const gTypeOfRoles = [
  { value: "1", label: "Registrar" },
  { value: "2", label: "Customers" },
  { value: "3", label: "Subadmins" },
  { value: "4", label: "Reports" },
];

export const acReadingBy = [
  { value: 1, label: "Room" },
  { value: 2, label: "Tenant" },
];

export const staff_roles = [
  { label: "Admin", value: Config.STAFF_ROLES.ADMIN },
  { label: "Partner", value: Config.STAFF_ROLES.PARTNER },
  {
    label: "Warden",
    value: Config.STAFF_ROLES.WARDEN,
  },
  { label: "Sales Person", value: Config.STAFF_ROLES.SALESPERSON },
  { label: "Plumber", value: Config.STAFF_ROLES.PLUMBER },
  { label: "Electrician", value: Config.STAFF_ROLES.ELECTRICIAN },
  { label: "Laundry", value: Config.STAFF_ROLES.LAUNDRY },
  { label: "Carpenter", value: Config.STAFF_ROLES.CARPENTER },
  { label: "Cook", value: Config.STAFF_ROLES.COOK },
  { label: "House Keeping", value: Config.STAFF_ROLES.HOUSEKEEPING },
  { label: "Security Guard", value: Config.STAFF_ROLES.SECURITYGUARD },
  { label: "Finance Admin", value: Config.STAFF_ROLES.FINANCEADMIN },
  { label: "Back Office", value: Config.STAFF_ROLES.BACK_OFFICE },
  { label: "Help Desk", value: Config.STAFF_ROLES.HELPDESK },
  { label: 'Broker', value: Config.STAFF_ROLES.BROKER },
  { label: 'AC Tech', value: Config.STAFF_ROLES.AC_TECH },
  { label: 'Purifier Tech', value: Config.STAFF_ROLES.PURIFIER_TECH },
];

export const ownership_roles = [
  { label: "Owner", value: Config.PROPERTY_OWNERSHIP.OWNER },
  { label: "Co-Owner", value: Config.PROPERTY_OWNERSHIP.CO_OWNER },
  {
    label: "POA",
    value: Config.PROPERTY_OWNERSHIP.POA,
  },
  { label: "Builder", value: Config.PROPERTY_OWNERSHIP.BUILDER },
  { label: "Channel Partner", value: Config.PROPERTY_OWNERSHIP.CHANNEL_BROKER },
  {
    label: "Co-Broker",
    value: Config.PROPERTY_OWNERSHIP.CO_BROKER,
  },
];

export const inventoryAge = [
  { label: "New", value: Config.INVENTORY_AGE.NEW },
  { label: "1 Year", value: Config.INVENTORY_AGE.ONE },
  { label: "2 Year", value: Config.INVENTORY_AGE.TWO },
  { label: "3 Year", value: Config.INVENTORY_AGE.THREE },
  { label: "4 Year", value: Config.INVENTORY_AGE.FOUR },
  { label: "5 Year", value: Config.INVENTORY_AGE.FIVE },
  { label: "More than 5 Year", value: Config.INVENTORY_AGE.MORE },

];

export const listing_type = [
  { label: "Rent", value: Config.LISTING_TYPE.RENT },
  { label: "Sale", value: Config.LISTING_TYPE.SALE, disabled: true },
  // {
  //   label: "Lease",
  //   value: Config.LISTING_TYPE.LEASE,
  // },
];
export const landlord_property_type = [
  { label: "Independent Floor/Villa", value: Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR },
  {
    label: "Apartment/Flat",
    value: Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
  },
  { label: "PG", value: Config.LANDLORD_PROPERTY_TYPE.PG },

  // {
  //   label: "Independent Floor",
  //   value: Config.LANDLORD_PROPERTY_TYPE.INDEPENDENT_FLOOR,
  // },
  // { label: "Shop", value: Config.LANDLORD_PROPERTY_TYPE.SHOP },
  { label: "Showroom/Shop", value: Config.LANDLORD_PROPERTY_TYPE.SHOP_SHOWROOM },
  {
    label: "Office Space",
    value: Config.LANDLORD_PROPERTY_TYPE.OFFICE,
  },
  // {
  //   label: "Plot",
  //   value: Config.LANDLORD_PROPERTY_TYPE.PLOT,
  // },
  // {
  //   label: "Mixed Use",
  //   value: Config.LANDLORD_PROPERTY_TYPE.MIXED_USE,
  // },
];
// export const moveOutReasons = [
//   { label: "Job Transfer / Relocation", value: "relocation" },
//   { label: "Moving Closer to Workplace / College", value: "closer_to_work" },
//   { label: "Found Better Accommodation", value: "better_accommodation" },
//   { label: "End of Lease / Contract", value: "end_of_lease" },
//   { label: "Personal Reasons / Family Emergency", value: "personal_reasons" },
//   { label: "Cost / Rent Too High", value: "high_rent" },
//   { label: "Issues with Flatmates", value: "flatmate_issues" },
//   { label: "Unsatisfactory Maintenance / Services", value: "poor_services" },
//   { label: "Change in Financial Situation", value: "financial_change" },
//   { label: "Purchased Own Property", value: "own_property" },
//   { label: "Temporary Stay Completed", value: "temporary_stay" },
//   { label: "Property Owner Requested Move", value: "owner_request" },
//   { label: "Safety / Security Concerns", value: "safety_concerns" },
//   { label: "Shifted to Native City", value: "native_city" },
//   { label: "Migrating Abroad", value: "migrating_abroad" },
//   // { label: "Other (please specify)", value: "other" }
// ];

export const moveOutReasons = [
  { label: "Job Transfer / Relocation", value: "relocation" },
  { label: "Non-Payment or Consistent Delays in Rent", value: "non_payment" },
  { label: "Violation of Lease or Rental Agreement Terms", value: "violation" },
  { label: "Moving Closer to Workplace / College", value: "closer_to_work" },
  { label: "Found Better Accommodation", value: "better_accommodation" },
  { label: "End of Lease / Contract", value: "end_of_lease" },
  { label: "Personal Reasons / Family Emergency", value: "personal_reasons" },
  { label: "Cost / Rent Too High", value: "high_rent" },
  { label: "Issues with Flatmates", value: "flatmate_issues" },
  { label: "Unsatisfactory Maintenance / Services", value: "poor_services" },
  { label: "Engaging in illegal Activities", value: "illegal_activities" },
  { label: "Change in Financial Situation", value: "financial_change" },
  { label: "Purchased Own Property", value: "own_property" },
  { label: "Temporary Stay Completed", value: "temporary_stay" },
  { label: "Property Owner Requested Move", value: "owner_request" },
  { label: "Safety / Security Concerns", value: "safety_concerns" },
  { label: "Shifted to Native City", value: "native_city" },
  { label: "Migrating Abroad", value: "migrating_abroad" },
  // { label: "Other (please specify)", value: "other" }
];
export default Config;






















// import { useEffect, useState } from "react";
// import tw from "tailwind-styled-components";
// import { useMutation } from "react-query";
// import axios from "axios";
// import Config from "../../Config";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import {
//   BoxContainer,
//   BoxHead,
//   DownloadBtn,
//   Underline,
//   BoxTitle,
// } from "../../Components/Styles/PageStyles";
// import { capitalizeFirstLetter } from "../../helpers";
// import SideModal from "../../Components/SideModal";
// import NotFoundModel from "../../Components/NotFoundModel";
// // import { Tabs, Tab, Box } from "@mui/material";
// import {
//   MdClose,
//   MdFolder,
//   MdInsertDriveFile,
//   MdArrowBack,
//   MdAdd,
// } from "react-icons/md";
// import CreateFolder from "../../Components/Documents/CreateFolder";
// import { ModalHeader } from "../../Components/Styles/InputStyles";
// import PropertyDocumentUploadModal from "../../Components/Documents/PropertyDocumentModal";
// import Loading from "../../Components/Loading";
// import {
//   Tabs,
//   Tab,
//   Box,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   ListItemText,
// } from "@mui/material";

// import { MdUploadFile } from "react-icons/md";

// // Hardcoded data structure
// // const HARDCODED_DATA = {
// //     docs: [
// //         {
// //             id: "1",
// //             title: "Personal Documents",
// //             type: "folder",
// //             createdAt: "2024-01-15T10:30:00Z",
// //             children: [
// //                 {
// //                     id: "1-1",
// //                     title: "Aadhar Card",
// //                     type: "file",
// //                     value: "/files/aadhar.pdf",
// //                     createdAt: "2024-01-15T10:30:00Z",
// //                 },
// //                 {
// //                     id: "1-2",
// //                     title: "PAN Card",
// //                     type: "file",
// //                     value: "/files/pan.pdf",
// //                     createdAt: "2024-01-15T10:30:00Z",
// //                 },
// //                 {
// //                     id: "1-3",
// //                     title: "Passport",
// //                     type: "file",
// //                     value: "/files/passport.pdf",
// //                     createdAt: "2024-02-10T14:20:00Z",
// //                 },
// //                 {
// //                     id: "1-4",
// //                     title: "Bank Statements",
// //                     type: "folder",
// //                     createdAt: "2024-02-01T09:15:00Z",
// //                     children: [
// //                         {
// //                             id: "1-4-1",
// //                             title: "March 2024 Statement",
// //                             type: "file",
// //                             value: "/files/march_statement.pdf",
// //                             createdAt: "2024-03-01T11:00:00Z",
// //                         },
// //                         {
// //                             id: "1-4-2",
// //                             title: "April 2024 Statement",
// //                             type: "file",
// //                             value: "/files/april_statement.pdf",
// //                             createdAt: "2024-04-01T11:00:00Z",
// //                         },
// //                     ],
// //                 },
// //             ],
// //         },
// //         {
// //             id: "2",
// //             title: "Property Documents",
// //             type: "folder",
// //             createdAt: "2024-01-20T09:00:00Z",
// //             children: [
// //                 {
// //                     id: "2-1",
// //                     title: "Sale Deed",
// //                     type: "file",
// //                     value: "/files/sale_deed.pdf",
// //                     createdAt: "2024-01-20T09:00:00Z",
// //                 },
// //                 {
// //                     id: "2-2",
// //                     title: "Property Tax Receipts",
// //                     type: "folder",
// //                     createdAt: "2024-01-20T09:30:00Z",
// //                     children: [
// //                         {
// //                             id: "2-2-1",
// //                             title: "Tax Receipt 2023-24",
// //                             type: "file",
// //                             value: "/files/tax_2023.pdf",
// //                             createdAt: "2024-01-20T09:30:00Z",
// //                         },
// //                         {
// //                             id: "2-2-2",
// //                             title: "Tax Receipt 2024-25",
// //                             type: "file",
// //                             value: "/files/tax_2024.pdf",
// //                             createdAt: "2024-04-15T10:00:00Z",
// //                         },
// //                     ],
// //                 },
// //                 {
// //                     id: "2-3",
// //                     title: "Encumbrance Certificate",
// //                     type: "file",
// //                     value: "/files/encumbrance.pdf",
// //                     createdAt: "2024-02-05T13:45:00Z",
// //                 },
// //             ],
// //         },
// //         {
// //             id: "3",
// //             title: "Insurance Documents",
// //             type: "folder",
// //             createdAt: "2024-02-10T11:20:00Z",
// //             children: [
// //                 {
// //                     id: "3-1",
// //                     title: "Health Insurance",
// //                     type: "file",
// //                     value: "/files/health_insurance.pdf",
// //                     createdAt: "2024-02-10T11:20:00Z",
// //                 },
// //                 {
// //                     id: "3-2",
// //                     title: "Property Insurance",
// //                     type: "file",
// //                     value: "/files/property_insurance.pdf",
// //                     createdAt: "2024-02-10T11:20:00Z",
// //                 },
// //             ],
// //         },
// //         {
// //             id: "4",
// //             title: "Electricity Bill - March 2024",
// //             type: "file",
// //             value: "/files/electricity_bill.pdf",
// //             createdAt: "2024-03-15T08:00:00Z",
// //         },
// //         {
// //             id: "5",
// //             title: "Water Bill - March 2024",
// //             type: "file",
// //             value: "/files/water_bill.pdf",
// //             createdAt: "2024-03-15T08:30:00Z",
// //         },
// //     ],
// // };

// const OwnerDocuments = () => {
//   const user = useSelector((state) => state.UserReducer.user);
//   const [currentPath, setCurrentPath] = useState([]); // Stack of folder navigation
//   const [currentItems, setCurrentItems] = useState([]);
//   const [isActionModalOpen, setIsActionModalOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState(0);
//   const [anchorEl, setAnchorEl] = useState(null);
//   // const [isUsingHardcoded, setIsUsingHardcoded] = useState(false);
//   const [apiData, setApiData] = useState();
//   // Initialize with hardcoded data or API data
//   // useEffect(() => {
//   //     if (isUsingHardcoded) {
//   //         setCurrentItems(HARDCODED_DATA.docs);
//   //     } else {
//   //         // Original API call logic
//   //         getListMutate();
//   //     }
//   // }, [isUsingHardcoded]);

//   // useEffect(() => {
//   //   getListMutate();
//   // }, []);
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       getListMutate();
//     }, 500);

//     return () => clearTimeout(handler);
//   }, []);

//   // const fetchFunction = async () => {
//   //   const response = await axios.get(
//   //     `${Config.apiUrl}/uploadDocument/listfolder`,
//   //     {
//   //       headers: {
//   //         authorization: `Bearer ${user.token}`,
//   //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//   //       },
//   //     },
//   //   );
//   //   return response.data;
//   // };
// const fetchFunction = async (folderId) => {
//   const response = await axios.get(
//     `${Config.apiUrl}/uploadDocument/listfolder`,
//     {
//       params: {
//         folderId, // sends ?folderId=18
//       },
//       headers: {
//         authorization: `Bearer ${user.token}`,
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//       },
//     }
//   );

//   return response.data;
// };
//   // const getSuccess = (res) => {
//   //     if (res.data === false) error = true;
//   //     else {
//   //         setApiData(res?.data);
//   //         setCurrentItems(res?.data?.docs);
//   //     }
//   // };
//   const getSuccess = (res) => {
//     if (!res.isSuccess) {
//       toast.error(res.msg);
//       return;
//     }

//     setApiData(res.data);
//     setCurrentItems(res.data);
//   };

//   const getError = (res) => {};

//   const {
//     isLoading: getListLoading,
//     mutate: getListMutate,
//     error,
//     data,
//     isRefetching,
//   } = useMutation(fetchFunction, {
//     onSuccess: getSuccess,
//     onError: getError,
//   });
//   // console.log("Loading:", getListLoading);

//   //------- Upload Document -------
//   const uploadDocumentFunction = async (values) => {
//     // if (isUsingHardcoded) {
//     //     // Simulate API call for hardcoded data
//     //     return new Promise((resolve) => {
//     //         setTimeout(() => {
//     //             const newFile = {
//     //                 id: Date.now().toString(),
//     //                 title: values.get("title"),
//     //                 type: "file",
//     //                 value: URL.createObjectURL(values.get("file")),
//     //                 createdAt: new Date().toISOString(),
//     //             };

//     //             // Add to current items or nested folder
//     //             if (currentPath.length === 0) {
//     //                 setCurrentItems([...currentItems, newFile]);
//     //             } else {
//     //                 // Add to nested folder (simplified for demo)
//     //                 const updatedItems = [...currentItems];
//     //                 let current = updatedItems;
//     //                 for (let i = 0; i < currentPath.length - 1; i++) {
//     //                     const folder = current.find(
//     //                         (item) => item.id === currentPath[i].id && item.type === "folder"
//     //                     );
//     //                     if (folder) current = folder.children;
//     //                 }
//     //                 const targetFolder = current.find(
//     //                     (item) => item.id === currentPath[currentPath.length - 1]?.id
//     //                 );
//     //                 if (targetFolder && targetFolder.type === "folder") {
//     //                     if (!targetFolder.children) targetFolder.children = [];
//     //                     targetFolder.children.push(newFile);
//     //                 }
//     //                 setCurrentItems([...updatedItems]);
//     //             }
//     //             resolve({ data: { isSuccess: true, msg: "File uploaded successfully", docs: currentItems } });
//     //         }, 1000);
//     //     });
//     // }
//     return await axios.post(
//       `${Config.apiUrl}/uploadDocument/uploaddoc`,
//       values,
//       {
//         headers: {
//           authorization: `Bearer ${user.token}`,
//           "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         },
//       },
//     );
//   };

//   // const onUploadDocSuccess = (data) => {
//   //   setIsActionModalOpen(false);
//   //   setActiveTab(0);
//   //   if (data?.data?.isSuccess === true) {
//   //     // if (!isUsingHardcoded) {
//   //     setCurrentItems(data?.data?.docs);
//   //     // }
//   //     toast.success(data?.data?.msg || "Success");
//   //   } else {
//   //     toast.error(data?.data?.msg || "An Error Occured");
//   //   }
//   // };
//   const onUploadDocSuccess = (data) => {
//   setIsActionModalOpen(false);
//   setActiveTab(0);

//   if (!data?.data?.isSuccess) {
//     toast.error(data?.data?.msg || "An Error Occured");
//     return;
//   }

//   if (currentPath.length === 0) {
//     // Root
//     getListMutate();
//   } else {
//     // Current opened folder
//     const folderId = currentPath[currentPath.length - 1].id;
//     getListMutate(folderId);
//   }

//   toast.success(data.data.msg);
// };
//   // const onUploadDocSuccess = (data) => {
//   //   setIsActionModalOpen(false);
//   //   setActiveTab(0);

//   //   if (data?.data?.isSuccess) {
//   //     toast.success(data.data.msg);

//   //     getListMutate();
//   //   } else {
//   //     toast.error(data?.data?.msg || "An Error Occured");
//   //   }
//   // };

//   const onUploadDocError = (data) => {
//     setIsActionModalOpen(false);
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoading: isDocLoading, mutate: uploadDocMutate } = useMutation(
//     uploadDocumentFunction,
//     {
//       onSuccess: onUploadDocSuccess,
//       onError: onUploadDocError,
//     },
//   );

//   //------- Create Folder -------
//   const createFolderFunction = async (body) => {
//     // if (isUsingHardcoded) {
//     //     // Simulate API call for hardcoded data
//     //     return new Promise((resolve) => {
//     //         setTimeout(() => {
//     //             const newFolder = {
//     //                 id: Date.now().toString(),
//     //                 title: body.get("title"),
//     //                 type: "folder",
//     //                 createdAt: new Date().toISOString(),
//     //                 children: [],
//     //             };

//     //             // Add to current items or nested folder
//     //             if (currentPath.length === 0) {
//     //                 setCurrentItems([...currentItems, newFolder]);
//     //             } else {
//     //                 const updatedItems = [...currentItems];
//     //                 let current = updatedItems;
//     //                 for (let i = 0; i < currentPath.length - 1; i++) {
//     //                     const folder = current.find(
//     //                         (item) => item.id === currentPath[i].id && item.type === "folder"
//     //                     );
//     //                     if (folder) current = folder.children;
//     //                 }
//     //                 const targetFolder = current.find(
//     //                     (item) => item.id === currentPath[currentPath.length - 1]?.id
//     //                 );
//     //                 if (targetFolder && targetFolder.type === "folder") {
//     //                     if (!targetFolder.children) targetFolder.children = [];
//     //                     targetFolder.children.push(newFolder);
//     //                 }
//     //                 setCurrentItems([...updatedItems]);
//     //             }
//     //             resolve({ data: { isSuccess: true, msg: "Folder created successfully" } });
//     //         }, 1000);
//     //     });
//     // }
//     return await axios.post(
//       `${Config.apiUrl}/uploadDocument/createfolder`,
//       body,
//       {
//         headers: {
//           authorization: `Bearer ${user.token}`,
//           "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         },
//       },
//     );
//   };

//   // const onCreateFolderSuccess = (data) => {
//   //   if (data?.data?.isSuccess === true) {
//   //     setIsActionModalOpen(false);
//   //     setActiveTab(0);
//   //     // if (!isUsingHardcoded) {
//   //     getListMutate();
//   //     // }
//   //     toast.success(data?.data?.msg || "Folder created successfully");
//   //   } else {
//   //     toast.error(data?.data?.msg || "An Error Occured");
//   //   }
//   // };
//   // const onCreateFolderSuccess = (data) => {
//   //   if (!data?.data?.isSuccess) {
//   //     toast.error(data?.data?.msg || "An Error Occured");
//   //     return;
//   //   }

//   //   setIsActionModalOpen(false);
//   //   setActiveTab(0);

//   //   if (currentPath.length === 0) {
//   //     // Root folder
//   //     getListMutate();
//   //   } else {
//   //     // We are inside a folder
//   //     // DON'T call root API
//   //     // Wait for backend API to load this folder
//   //   }

//   //   toast.success(data.data.msg);
//   // };
//   const onCreateFolderSuccess = (data) => {
//   if (!data?.data?.isSuccess) {
//     toast.error(data?.data?.msg || "An Error Occured");
//     return;
//   }

//   setIsActionModalOpen(false);
//   setActiveTab(0);

//   if (currentPath.length === 0) {
//     getListMutate();
//   } else {
//     const folderId = currentPath[currentPath.length - 1].id;
//     getListMutate(folderId);
//   }

//   toast.success(data.data.msg);
// };
//   const onCreateFolderError = (data) => {
//     setIsActionModalOpen(false);
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoading: isCreateLoading, mutate: createFolderMutate } =
//     useMutation(createFolderFunction, {
//       onSuccess: onCreateFolderSuccess,
//       onError: onCreateFolderError,
//     });

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   // const handleButtonClick = () => {
//   //   setIsActionModalOpen(true);
//   // };

//   const handleButtonClick = (event) => {
//   setAnchorEl(event.currentTarget);
// };

// const handleCloseMenu = () => {
//   setAnchorEl(null);
// };

// const handleUploadClick = () => {
//   setActiveTab(0);
//   setIsActionModalOpen(true);
//   handleCloseMenu();
// };

// const handleCreateFolderClick = () => {
//   setActiveTab(1);
//   setIsActionModalOpen(true);
//   handleCloseMenu();
// };

//   const handleCloseModal = () => {
//     setIsActionModalOpen(false);
//     setActiveTab(0);
//   };

//   // Navigate into a folder
//   const handleFolderClick = (folder) => {
//     console.log("Folder:", folder);
//   console.log("Folder ID:", folder.id);
//   getListMutate(folder.id);
//     setCurrentPath([...currentPath, { id: folder.id, title: folder.name }]);
//     // setCurrentItems(folder.children || []);
//   };

//   // Navigate back
//   // const handleBackClick = () => {
//   //     const newPath = [...currentPath];
//   //     newPath.pop();
//   //     setCurrentPath(newPath);

//   //     if (newPath.length === 0) {
//   //         // setCurrentItems(HARDCODED_DATA.docs);
//   //         getListMutate();
//   //     } else {
//   //         // Find the folder at the new path
//   //         let items = HARDCODED_DATA.docs;
//   //         for (const segment of newPath) {
//   //             const folder = items.find((item) => item.id === segment.id && item.type === "folder");
//   //             if (folder && folder.children) {
//   //                 items = folder.children;
//   //             }
//   //         }
//   //         setCurrentItems(items);
//   //     }
//   // };
//   const handleBackClick = () => {
//     const newPath = [...currentPath];
//     newPath.pop();

//     setCurrentPath(newPath);

//     if (newPath.length === 0) {
//       // Back to root folders
//       getListMutate();
//     } else {
//       // Load previous folder
//       const previousFolderId = newPath[newPath.length - 1].id;
//       getListMutate(previousFolderId); // or getFolderMutate(previousFolderId)
//     }
//   };

//   const formatDate = (date) => {
//     if (!date) return "";
//     try {
//       return new Date(date).toLocaleDateString("en-US", {
//         month: "long",
//         day: "numeric",
//         year: "numeric",
//       });
//     } catch {
//       return "";
//     }
//   };

//   // Render breadcrumb navigation
//   const renderBreadcrumb = () => {
//     return (
//       <div className="flex items-center gap-2 flex-wrap">
//         {currentPath.length > 0 && (
//           <button
//             onClick={handleBackClick}
//             className="flex items-center gap-1 text-primary-color hover:underline text-sm"
//           >
//             <MdArrowBack size={16} />
//             Back
//           </button>
//         )}
//         <div className="flex items-center gap-1 text-sm text-gray-600">
//           <span className="font-medium">Root</span>
//           {currentPath.map((folder, index) => (
//             <span key={index} className="flex items-center gap-1">
//               <span className="text-gray-400">/</span>
//               <span className="font-medium">{folder.title}</span>
//             </span>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <BoxContainer className="!h-auto">
//       <BoxHead>
//         <BoxTitle className="!mb-0 whitespace-nowrap">
//           Documents
//           <Underline />
//         </BoxTitle>

//         <DownloadBtn type="button" onClick={handleButtonClick}>
//           <MdAdd 
//            size={18} 
//            className="pr-[2px]"
//           />
//           New
//         </DownloadBtn>
//         <Menu
//   anchorEl={anchorEl}
//   open={Boolean(anchorEl)}
//   onClose={handleCloseMenu}
//   anchorOrigin={{
//     vertical: "bottom",
//     horizontal: "right",
//   }}
//   transformOrigin={{
//     vertical: "top",
//     horizontal: "right",
//   }}
// >
//   <MenuItem onClick={handleUploadClick}>
//     <ListItemIcon>
//       <MdUploadFile size={20} />
//     </ListItemIcon>
//     <ListItemText>Upload Document</ListItemText>
//   </MenuItem>

//   <MenuItem onClick={handleCreateFolderClick}>
//     <ListItemIcon>
//       <MdFolder size={20} />
//     </ListItemIcon>
//     <ListItemText>Create Folder</ListItemText>
//   </MenuItem>
// </Menu>
//       </BoxHead>

//       {renderBreadcrumb()}
//       {!error && !getListLoading && data && (
//         <>
//           {!currentItems || currentItems.length === 0 ? (
//             <NotFoundModel msg={"No documents or folders found"} />
//           ) : (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-4">
//               {currentItems.map((item, index) => {
//                 const itemDate = item?.createdAt;
//                 const isFolder = item.type === "folder";

//                 return (
//                   <DocCard
//                     key={index}
//                     className={
//                       isFolder ? "cursor-pointer hover:bg-gray-50" : ""
//                     }
//                     onClick={() => isFolder && handleFolderClick(item)}
//                   >
//                     <div className="flex items-center gap-2 mb-2">
//                       {isFolder ? (
//                         <MdFolder size={24} className="text-yellow-500" />
//                       ) : (
//                         <MdInsertDriveFile
//                           size={24}
//                           className="text-blue-500"
//                         />
//                       )}
//                       <span className="text-sm font-semibold text-gray-800">
//                         {/* {capitalizeFirstLetter(
//                           item?.name || (isFolder ? "Folder" : "Document"),
//                         )} */}
//                         {capitalizeFirstLetter(
//                             item.type === "folder"
//                               ? item.name
//                               : item.title
//                           )}
//                       </span>
//                     </div>

//                     {itemDate ? (
//                       <span className="text-xs text-gray-400 mt-1">
//                         {formatDate(itemDate)}
//                       </span>
//                     ) : null}

//                     {!isFolder && (
//                       <a
//                         href={item?.fileUrl}
//                         // href={`${Config.apiUrl}/uploads/${item.path}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="mt-3 text-sm font-medium text-primary-color hover:underline"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         View / Download
//                       </a>
//                     )}

//                     {isFolder && (
//                       <span className="mt-3 text-xs text-gray-500">
//                         {item.contentCount || 0} item(s)
//                       </span>
//                     )}
//                   </DocCard>
//                 );
//               })}
//             </div>
//           )}
//         </>
//       )}

//       {error && !getListLoading && (
//         <NotFoundModel msg="No documents or folders found" />
//       )}

//       {(getListLoading || isRefetching) && <Loading />}

//       <SideModal isOpen={isActionModalOpen} onClose={handleCloseModal}>
//         <ModalContainer>
//           <ModalHeader>
//             <h1 className="text-white text-lg font-medium">Manage Documents</h1>
//             <button onClick={handleCloseModal}>
//               <MdIcon color="white" size={24} />
//             </button>
//           </ModalHeader>

//           <Box sx={{ borderBottom: 1, borderColor: "divider", px: 2 }}>
//             <Tabs
//               value={activeTab}
//               onChange={handleTabChange}
//               sx={{
//                 "& .MuiTab-root": {
//                   textTransform: "none",
//                   fontSize: "14px",
//                   minWidth: "auto",
//                   px: 2,
//                   py: 1.5,
//                 },
//                 "& .Mui-selected": {
//                   color: "#26A69A !important",
//                 },
//                 "& .MuiTabs-indicator": {
//                   backgroundColor: "#26A69A",
//                 },
//               }}
//             >
//               <Tab label="Upload Document" />
//               <Tab label="Create Folder" />
//             </Tabs>
//           </Box>

//           <div className="flex-1 overflow-auto">
//             {activeTab === 0 ? (
//               <PropertyDocumentUploadModal
//                 handleClose={handleCloseModal}
//                 setIsDocumentAdd={setIsActionModalOpen}
//                 uploadDocMutate={uploadDocMutate}
//                 isDocLoading={isDocLoading}
//                 isModal={true}
//                 currentPath={currentPath}
//                 folders={apiData || []}
//               />
//             ) : (
//               <CreateFolder
//                 handleClose={handleCloseModal}
//                 setIsCreateFolder={setIsActionModalOpen}
//                 createFolderMutate={createFolderMutate}
//                 isCreateLoading={isCreateLoading}
//                 isModal={true}
//                 currentPath={currentPath}
//                 userId={user.id}
//               />
//             )}
//           </div>
//         </ModalContainer>
//       </SideModal>
//     </BoxContainer>
//   );
// };

// export default OwnerDocuments;

// const DocCard = tw.div`
// flex flex-col items-start 
// bg-white border border-gray-200 
// p-4 rounded-xl shadow-sm 
// hover:shadow-md transition-all duration-200
// `;

// const ModalContainer = tw.div`
// bg-white w-full h-full flex flex-col
// `;

// // const ModalHeader = tw.div`
// // bg-[#0078BD] px-6 py-4 flex justify-between items-center sticky top-0 z-10
// // `;

// const MdIcon = tw(MdClose)`
// cursor-pointer hover:opacity-80 transition-opacity
// `;
